import {Component, OnInit} from '@angular/core';

import {environment} from "@environments/environment";

// Config
import {Config} from '@core/config/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public isLoadingApp = true;
  public isProduction = environment.production;

  public version = environment.version;

  ngOnInit() {
    setTimeout(() => this.isLoadingApp = false, Config.LOADING_APP_TIME);
  }

}
